import React,{useMemo,useState} from "react"
import styled from '@emotion/styled'
import Helper from '../functions/Helper.js';
import Modal from 'react-bootstrap/Modal';
import Popup from './Popup.js';


const ResponsiveButton = styled.div(props=>({
  "@media (max-width:576px)":{
    padding:"0.6rem 1.5rem",
    fontSize:18,
  },
  display:"inline-block",
  cursor:"pointer",
  backgroundColor:"rgb(255, 90, 95)",
  textAlign:"center",
  color:"#fff",
  fontSize: 20,
  padding:"0.7rem 2rem",
  fontWeight:"bold!important",
  lineHeight: 1.5,
  borderRadius:3,
  boxShadow: "0px 2px 6px 0px rgba(55,55,55,0.2)",
  ...props.style,
  "&:hover":{
    color:"#fff"
  },
  "&:focus":{
    color:"#fff"
  }
}))

const ResponsiveLink = ResponsiveButton.withComponent('a')


function BuyButton(props){
  let colorways_by_shop=useMemo(()=>Helper.sort_colorways_by_shop(props.shoe.colorways),[props.shoe.colorways])
  let firstColorway=colorways_by_shop[0].colorways[0];
  var discount=Math.round((1-(firstColorway.price_discount/firstColorway.list_price))*100);
  const[showingModal,setModalStatus]=useState(false);

  if(colorways_by_shop.length>1 && firstColorway){
    return(
      <>
        <Modal dialogClassName="thg_popup_modal" onHide={()=>{setModalStatus(false)}} show={showingModal}>
          <Popup prefix={props.prefix} lastUpdate={props.lastUpdate} hideModal={()=>{setModalStatus(false)}} colorways_by_shop={colorways_by_shop} shoe={props.shoe}/>
        </Modal>
        <div style={{marginBottom:5,marginLeft:10,marginRight:10}}>
          {
            discount>0 ?
            <span style={{fontSize:16,textDecorationLine:"line-through"}}>
              ${Math.round(firstColorway.list_price)}
            </span>:
            <span style={{fontSize:16}}>
              from
            </span>
          }
          <span style={{marginLeft:5,fontSize:22,fontWeight:"bold"}}>
              ${Number(props.shoe.discount).toFixed(2)}
          </span>
        </div>
        <ResponsiveButton style={props.style} onClick={()=>setModalStatus(true)}>
          <i className="fas fa-shopping-cart" style={{marginRight: 10}}></i>
          Buy from {colorways_by_shop.length} Shops
        </ResponsiveButton>

      </>
    )
  }

  else if(colorways_by_shop.length===1 && firstColorway){
    return(
      <>
        <div style={{marginBottom:5,marginLeft:10,marginRight:10}}>
          {
            discount>0 ?
            <span style={{fontSize:16,textDecorationLine:"line-through"}}>
              ${Math.round(firstColorway.list_price)}
            </span>:
            <span style={{fontSize:16}}>
              from
            </span>
          }
          <span style={{marginLeft:5,fontSize:22,fontWeight:"bold"}}>
              ${Number(props.shoe.discount).toFixed(2)}
          </span>
        </div>
        <ResponsiveLink
          style={props.style}
          target='_blank'
          rel='noopener noreferrer nofollow'
          href={Helper.insert_link(firstColorway.link_url, props.prefix + "_button",firstColorway.tracking_id)}>
          <i style={{marginRight:"10px"}} className="fas fa-shopping-cart"/>
          Buy from {firstColorway.shop_name}
        </ResponsiveLink>
      </>
    )
  }

  else if(props.shoe.resells && props.shoe.resells.length>0){
    let firstResell=props.shoe.resells[0];
    return(
      <>
        <div style={{marginBottom:5,marginLeft:10,marginRight:10}}>
          {
            discount>0 ?
            <span style={{fontSize:16,textDecorationLine:"line-through"}}>
              ${Math.round(firstColorway.list_price)}
            </span>:
            <span style={{fontSize:16}}>
              from
            </span>
          }
          <span style={{marginLeft:5,fontSize:22,fontWeight:"bold"}}>
              ${Number(firstResell.price).toFixed(2)}
          </span>
        </div>
        <ResponsiveLink
          style={props.style}
          target='_blank'
          rel='noopener noreferrer nofollow'
          href={Helper.insert_link(firstResell.link_url, props.linkId,firstResell.tracking_id)}>
          <i style={{marginRight:"10px"}} className="fas fa-shopping-cart"/>
          Buy from {firstResell.shop_name}
        </ResponsiveLink>
      </>
    );
  }

  else{
    return(null)
  }
}

export default BuyButton
